export default __webpack_public_path__ + "static/media/ic_order.78ebf136.svg";